/* eslint-disable */
import {
  useElement,
  useState,
  useStaleLayout,
  useRect,
  useEffect,
  useModel,
} from '@nebula.js/stardust';
import picassojs from 'picasso.js';
import numeral from 'numeral';
import picassoQ from 'picasso-plugin-q';
import picassoHammer from 'picasso-plugin-hammer';
import * as d3 from 'd3';
import languagify from 'utils/languagify';

export default function supernova() {
  const picasso = picassojs();
  picasso.use(picassoQ);
  picasso.use(picassoHammer);

  return {
    qae: {
      properties: {
        qHyperCubeDef: {
          qDimensions: [],
          qMeasures: [],
          qInitialDataFetch: [{ qWidth: 2, qHeight: 5000 }],
          qSuppressZero: false,
          qSuppressMissing: true,
        },
        showTitles: true,
        title: '',
        subtitle: '',
        footnote: '',
      },
      data: {
        targets: [
          {
            path: '/qHyperCubeDef',
            dimensions: {
              min: 1,
              max: 1,
            },
            measures: {
              min: 1,
              max: 1,
            },
          },
        ],
      },
    },
    component() {
      const element = useElement();
      const layout = useStaleLayout();
      const rect = useRect();
      const model = useModel();

      const [instance, setInstance] = useState();

      useEffect(() => {
        const p = picasso.chart({
          element,
          data: [],
          settings: {},
        });

        setInstance(p);

        return () => {
          p.destroy();
        };
      }, []);

      useEffect(() => {
        if (!instance) {
          return;
        }

        // Selected Race
        const selectedRace = layout.qHyperCube.qDataPages[0].qMatrix.filter((row) => row[0].qState === 'S').map((row) => row[0].qText);

        const colorScale = d3.scaleOrdinal()
          .domain(['White', 'Unknown', 'Asian', 'Indigenous', 'Mixed Race', 'Black', 'Middle Eastern', 'Latin'])
          .range(['#A7A4D4', '#A55886', '#C17A82', '#408CA0', '#6BE0DD', '#A55886', '#E8CEAA', '#A2C3B4']);

        instance.update({
          data: [
            {
              type: 'q',
              key: 'qHyperCube',
              data: layout.qHyperCube,
            },
          ],
          settings: {
            formatters: {
              percent: {
                formatter: 'd3',
                type: 'number',
                format: ',.0%',
              },
            },

            scales: {
              y: {
                data: {
                  field: 'qMeasureInfo/0',
                },
                invert: true,
                include: [0, 1],
                max: 1.2,
              },
              color: {
                data: {
                  extract: {
                    field: 'qMeasureInfo/0',
                  },
                },
                range: [
                  '#a7a4d4',
                  '#A55886',
                  '#C17A82',
                  '#408CA0',
                  '#4CDBD7',
                  '#ABABA9',
                  '#BDD4C8',
                  '#BDD4C8',
                ],
                type: 'color',
              },
              x: {
                data: {
                  extract: {
                    field: 'qDimensionInfo/0',
                  },
                },
                invert: true,
                paddingInner: 0.1,
              },
            },
            components: [
              {
                type: 'axis',
                dock: 'bottom',
                scale: 'x',
                // formatter: 'myFormatter',
                // settings: {
                //   labels: {
                //     show: true,
                //     fontSize: 11,
                //     mode: 'tilted',
                //     tiltAngle: 60,
                //   },
                // },
              },
              {
                type: 'axis',
                dock: 'left',
                scale: 'y',
                formatter: 'percent',
              },
              {
                key: 'bars',
                type: 'box',
                data: {
                  extract: {
                    field: 'qDimensionInfo/0',
                    props: {
                      start: 0,
                      end: { field: 'qMeasureInfo/0' },
                    },
                  },
                },
                settings: {
                  major: { scale: 'x' },
                  minor: { scale: 'y' },
                  box: {
                    fill: (d) => {
                      if (selectedRace.length) {
                        if (selectedRace.includes(d.datum.label)) {
                          return colorScale(d.datum.label);
                        }
                        return '#D3D3D3';
                      }
                      return colorScale(d.datum.label);
                    },

                  },
                },
              },
              // labels({ c: 'bars' }),
              {
                type: 'labels',
                displayOrder: 2,
                settings: {
                  sources: [{
                    component: 'bars',
                    selector: 'rect',
                    strategy: {
                      type: 'bar',
                      settings: {
                        direction: 'up',
                        labels: [{
                          placements: [{
                            position: 'outside',
                          }],
                          label: (node) => numeral(node.data.end.value).format('0.0%'),
                        }],
                        fontSize: 10,
                      },
                    },
                  }],
                },
              },
            ],
            interactions: [
              {
                type: 'native',
                events: {
                  // click(e) {
                  //   const chartBounds = element.getBoundingClientRect();
                  //   const cx = e.clientX - chartBounds.left;
                  //   const cy = e.clientY - chartBounds.top;
                  //   const shapes = this.chart.shapesAt({ x: cx, y: cy });
                  //   const values = shapes.map((shape) => shape.data.value);
                  //   model.selectHyperCubeValues('/qHyperCubeDef', 0, values, true);
                  // },
                },
              },
              {
                type: 'hammer',
                gestures: [
                  {
                    type: 'Tap',
                    events: {
                      tap(e) {
                        const chartBounds = element.getBoundingClientRect();
                        const cx = e.center.x - chartBounds.left;
                        const cy = e.center.y - chartBounds.top;
                        const shapes = this.chart.shapesAt({ x: cx, y: cy });
                        const values = shapes.map((shape) => shape.data.value);
                        model.selectHyperCubeValues('/qHyperCubeDef', 0, values, true);
                      },
                    },
                  },
                ],
              },
            ],
          },
        });

        setTimeout(() => {
          if (instance.element.querySelector('[data-label="White"]')) instance.element.querySelector('[data-label="White"]').textContent = languagify(instance.element.querySelector('[data-label="White"]').textContent);
          if (instance.element.querySelector('[data-label="Black"]')) instance.element.querySelector('[data-label="Black"]').textContent = languagify(instance.element.querySelector('[data-label="Black"]').textContent);
          if (instance.element.querySelector('[data-label="Asian"]')) instance.element.querySelector('[data-label="Asian"]').textContent = languagify(instance.element.querySelector('[data-label="Asian"]').textContent);
          if (instance.element.querySelector('[data-label="Latin"]')) instance.element.querySelector('[data-label="Latin"]').textContent = languagify(instance.element.querySelector('[data-label="Latin"]').textContent);
          if (instance.element.querySelector('[data-label="Middle Eastern"]')) instance.element.querySelector('[data-label="Middle Eastern"]').textContent = languagify(instance.element.querySelector('[data-label="Middle Eastern"]').textContent);
          if (instance.element.querySelector('[data-label="Mixed Race"]')) instance.element.querySelector('[data-label="Mixed Race"]').textContent = languagify(instance.element.querySelector('[data-label="Mixed Race"]').textContent);
          if (instance.element.querySelector('[data-label="Indigenous"]')) instance.element.querySelector('[data-label="Indigenous"]').textContent = languagify(instance.element.querySelector('[data-label="Indigenous"]').textContent);
        }, 1000);
      }, [layout, instance]);

      useEffect(() => {
        if (!instance) {
          return;
        }
        instance.update();
      }, [rect.width, rect.height, instance]);
    },
  };
}
